export default {
  cardPack: 'Kartenpaket',
  cardsSuffix: '-Karten',
  cardPower: 'Kartenkraft',
  cardPowerValue: '{0} Kartenkraft',
  cardPowerDescription: 'Die Kartenkraft aller aktiven Karten wird addiert und erhöht grundlegende Werte der Funktion',
  notFound: 'Keine Karten gefunden',
  fullCollectionReward: 'Belohnung für volle Sammlung',
  canFind: 'Diese Karte kann in folgenden Paketen gefunden werden',
  cannotFind: 'Diese Karte kann aktuell in keinen Paketen gefunden werden',
  active: 'Aktive Karten',
  equipped: 'Karten angelegt',
  onActive: 'wenn aktiv',
  onDuplicate: 'bei Doppelten',
  activeDescription: 'Doppelte Karten können ausgerüstet werden und werden beim nächsten Prestige verbraucht, um deren Effekte zu aktivieren. Diese Effekte bleiben bis zum folgenden Prestige erhalten.',
  shinyTitle: 'Glitzerkarten',
  shinyDescription: 'Karten aus Kartenpaketen haben eine {0}% Chance, glitzernd zu sein. Glitzerkarten geben der Karte für immer +1 Kartenkraft, und erhöhen das Prestigeeinkommen für die Funktion.',
  sort: {
    number: 'Kartennummer',
    power: 'Höchste Kraft',
    owned: 'Meiste im Besitz',
  },
  equipTutorial: {
    description: 'Du hast deine ersten Karten gesammelt! Die meisten Karten haben einen Effekt, wenn sie aktiv sind, welcher auf folgende Art genutzt werden kann:',
    1: 'Erhalte eine doppelte Karte',
    2: 'Schalte Prestige für eine deiner Hauptfunktionen frei',
    3: 'Gehe ins Prestigemenü und lege die doppelte Karte an (muss die gleiche Funktion sein wie unten rechts auf der Karte)',
    4: 'Führe einen Prestige mit der angelegten Karte durch',
    5: 'Die Karte wird verbraucht und die Effekt sind bis zum nächsten Prestige aktiv'
  },
  card: {
    'MI-0001': 'Grundlegende Ausrüstung',
    'MI-0002': 'Unbenutzte Spitzhacke',
    'MI-0003': 'Spitzhackenkiste',
    'MI-0004': 'Lunte anzünden!',
    'MI-0005': 'In die Tiefen',
    'MI-0006': 'Helmregal',
    'MI-0007': 'In Deckung!',
    'MI-0008': 'Harte Arbeit',
    'MI-0009': 'Spitzhacke oder Schaufel?',
    'MI-0010': 'Zu klein',
    'MI-0011': 'Motivierter Arbeiter',
    'MI-0012': 'Arbeitsunfall',
    'MI-0013': 'Temporäres Lager',
    'MI-0014': 'Gefüllte Kiste',
    'MI-0015': 'An die Oberfläche',
    'MI-0016': 'Extraktion',
    'MI-0017': 'Transport',
    'MI-0018': 'Qualitätskontrolle',
    'MI-0019': 'Recyclingfabrik',
    'MI-0020': 'Hydraulische Presse',
    'MI-0021': 'Raffinerie-Experiment',
    'MI-0022': 'Roboterbau',
    'MI-0023': 'Feststeckende Spitzhacke',
    'MI-0024': 'Bergwerkeingang',
    'MI-0025': 'Felshaufen sprengen',
    'MI-0026': 'Minenschacht',
    'MI-0027': 'Oberflächenstein',
    'MI-0028': 'Fledermäuse stören',
    'MI-0029': 'Kriechende Krabbler',
    'MI-0030': 'Seltener Fund',
    'MI-0031': 'Unterirdischer See',
    'MI-0032': 'Brennbare Flüssigkeit',
    'MI-0033': 'Unterirdischer Friedhof',
    'MI-0034': 'Lauernde Spinne',
    'MI-0035': 'Kein Entkommen',
    'MI-0036': 'Erdbeben',
    'MI-0037': 'Giftgas',
    'MI-0038': 'Kristallstacheln',
    'MI-0039': 'Spitzhacke',
    'MI-0040': 'Schaufel',
    'MI-0041': 'Kristall',
    'MI-0042': 'Flasche',
    'MI-0043': 'Höhle',
    'MI-0044': 'Feuer',
    'MI-0045': 'Baum',
    'MI-0046': 'Glühbirne',
    'MI-0047': 'Bemooster Stein',
    'MI-0048': 'Bananenstaude',
    'MI-0049': 'Höhlenwurzel',
    'MI-0050': 'Seltsame Pilze',
    'MI-0051': 'Saatkisten',
    'MI-0052': 'Feuerblume',
    'MI-0053': 'Leuchtender Farn',
    'MI-0054': 'Baum des Lebens',
    'MI-0055': 'Doppelseitige Spitzhacke',
    'MI-0056': 'Kristallhöhle',
    'MI-0057': 'Nitro',
    'MI-0058': 'Mehrfachlager',
    'MI-0059': 'Ziegelwand',

    'VI-0001': 'Massive Felsen',
    'VI-0002': 'Versteckter Edelstein',
    'VI-0003': 'Tropfsteinhöhle',
    'VI-0004': 'Zwei Wege',
    'VI-0005': 'Höhlenblumen',
    'VI-0006': 'Outdoor-Camping',
    'VI-0007': 'Spielplatz',
    'VI-0008': 'Ruhige Gegend',
    'VI-0009': 'Wütender Nachbar',
    'VI-0010': 'Haus mit Garten',
    'VI-0011': 'Häuserbau',
    'VI-0012': 'Campingausflug',
    'VI-0013': 'Wohnzimmer',
    'VI-0014': 'Hundehütte',
    'VI-0015': 'Dachgarten',
    'VI-0016': 'Jahrhundertsbaum',
    'VI-0017': 'Holzdiebstahl',
    'VI-0018': 'Gemeinschafts-Garten',
    'VI-0019': 'Aufforsten',
    'VI-0020': 'Abholzen',
    'VI-0021': 'Holztransporter',
    'VI-0022': 'Forschungslabor',
    'VI-0023': 'Experiment',
    'VI-0024': 'Seuchenanalyse',
    'VI-0025': 'Barren formen',
    'VI-0026': 'Nagelfabrik',
    'VI-0027': 'Alte Bücherei',
    'VI-0028': 'Uhrwerk',
    'VI-0029': 'Kochroboter',
    'VI-0030': 'Ferngesteuerte Garage',
    'VI-0031': 'Generator',
    'VI-0032': 'Solarpanele',
    'VI-0033': 'Selbstfahrendes Auto',
    'VI-0034': 'Feuerwehr',
    'VI-0035': 'Polizeiwache',
    'VI-0036': 'Den Weg leuchten',
    'VI-0037': 'Hunderettung',
    'VI-0038': 'Krankenwagen',
    'VI-0039': 'Rettungsschwimmer',
    'VI-0040': 'Schlussverkauf',
    'VI-0041': 'Verlassene Fabrik',
    'VI-0042': 'Wolkenkratzer',
    'VI-0043': 'Möbelgeschäft',
    'VI-0044': 'Werkzeugschmied',
    'VI-0045': 'Tragbarer Generator',
    'VI-0046': 'Luftfilter',
    'VI-0047': 'Öltanker',
    'VI-0048': 'Steuerfahndung',
    'VI-0049': 'Luxusvilla',
    'VI-0050': 'Grüne Wiese',
    'VI-0051': 'Wunder',
    'VI-0052': 'Erneuerbare Energien',
    'VI-0053': 'Münzensammler',
    'VI-0054': 'Bauarbeiter und Werkzeug',
    'VI-0055': 'Personalvermittlung',
    'VI-0056': 'Bücherverkauf',
    'VI-0057': 'Trinkgeldglas',
    'VI-0058': 'Läufer',
    'VI-0059': 'Selbstgemachter Millionär',
    'VI-0060': 'Gepflegter Garten',
    'VI-0061': 'Verlobungsringe',
    'VI-0062': 'Werkbank',
    'VI-0063': 'Protest',
    'VI-0064': 'Naturkatastrophe',

    'HO-0001': 'Lauernde Schlange',
    'HO-0002': 'Tiefes Loch',
    'HO-0003': 'Ausbrechender Vulkan',
    'HO-0004': 'Verlaufen',
    'HO-0005': 'Ewig gefroren',
    'HO-0006': 'Magmakammer',
    'HO-0007': 'Taschenkontrolle',
    'HO-0008': 'Mauerbau',
    'HO-0009': 'Überwachungs-Kamera',
    'HO-0010': 'Pilzbuch',
    'HO-0011': 'Elektrozaun',
    'HO-0012': 'Megabombe',
    'HO-0013': 'Raketenwerfer',
    'HO-0014': 'Schwerterang',
    'HO-0015': 'Giftpfeil',
    'HO-0016': 'Lenkrakete',
    'HO-0017': 'Axtwerfer',
    'HO-0018': 'Mächtiger Stift',
    'HO-0019': 'Katapult',
    'HO-0020': 'Pistolenschwert',
    'HO-0021': 'Sonnenstrahlen',
    'HO-0022': 'Sägeblattwerfer',
    'HO-0023': 'Supersäure',
    'HO-0024': 'Natürliche Deckung',
    'HO-0025': 'Waldmeditation',
    'HO-0026': 'Metalldetektor',
    'HO-0027': 'Projektilschild',
    'HO-0028': 'Kraftfeld',
    'HO-0029': 'Radar',
    'HO-0030': 'Spion',
    'HO-0031': 'Korruption verboten',
    'HO-0032': 'Flüssigkeitsfilter',
    'HO-0033': 'Waschmaschine',
    'HO-0034': 'Mit Feuer töten',
    'HO-0035': 'Reinigungsstrahl',
    'HO-0036': 'Korruption zerstampfen',
    'HO-0037': 'In den Müll!',
    'HO-0038': 'Leuchtende Korruption',
    'HO-0039': 'Staubsauger',
    'HO-0040': 'Macht der Wissenschaft',
    'HO-0041': 'Korrupte Waffen',
    'HO-0042': 'Seltsames Ritual',
    'HO-0043': 'Einfach in die Mikrowelle',
    'HO-0044': 'Ninja',
    'HO-0045': 'Karate-Kämpfer',
    'HO-0046': 'Zen-Meditation',
    'HO-0047': 'Strategiezelt',
    'HO-0048': 'Phalanx',
    'HO-0049': 'Guillotine',
    'HO-0050': 'Gezacktes Messer',
    'HO-0051': 'Blutcontainer',
    'HO-0052': 'Heben und lernen',
    'HO-0053': 'Trankregal',
    'HO-0054': 'Pfandhaus',
    'HO-0055': 'Mensch und Maschine',
    'HO-0056': 'Gewichtheben-Wettbewerb',
    'HO-0057': 'Schriftrollen',
    'HO-0058': 'Bullseye!',
    'HO-0059': 'Kavallerie',
    'HO-0060': 'Marathon',
    'HO-0061': 'Elementarkugeln',
    'HO-0062': 'Abkürzung',
    'HO-0063': 'Roboterarme',
    'HO-0064': 'Weltmeister',
    'HO-0065': 'Beutemagnet',

    'FA-0001': 'Äpfel pflücken',
    'FA-0002': 'Kürbiswettbewerb',
    'FA-0003': 'Blumenladen',
    'FA-0004': 'Büropflanze',
    'FA-0005': 'Vogelscheuche',
    'FA-0006': 'Künstlicher Regen',
    'FA-0007': 'Versorgungszug',
    'FA-0008': 'Lebensmittel-Transport',
    'FA-0009': 'Warmes Gewächshaus',
    'FA-0010': 'Fruchtsmoothie',
    'FA-0011': 'Bäckereiverkauf',
    'FA-0012': 'Eiswagen',
    'FA-0013': 'Fastfood-Bestellung',
    'FA-0014': 'Festmahl',
    'FA-0015': 'Sußigkeitenland',
    'FA-0016': 'Teezeit',
    'FA-0017': 'Weinherstellung',
    'FA-0018': 'Kaffee und Kekse',
    'FA-0019': 'Oranges Gemüse',
    'FA-0020': 'Scharf-fruchtiges Rot',
    'FA-0021': 'Gänseblümchen-Gelb',
    'FA-0022': 'Pflanzengrün',
    'FA-0023': 'Blaubeerbusch',
    'FA-0024': 'Lila Pilze',
    'FA-0025': 'Käferpulver',
    'FA-0026': 'Frische Limette',
    'FA-0027': 'Schmetterlingsflügel',
    'FA-0028': 'Fruchtbarer Boden',
    'FA-0029': 'Gewitter',
    'FA-0030': 'Versalzene Erde',
    'FA-0031': 'Verkohlte Erde',
    'FA-0032': 'Scheune',
    'FA-0033': 'Gemüsesuppe',
    'FA-0034': 'Beerensaft',
    'FA-0035': 'Weizenfeld',
    'FA-0036': 'Riesige Sonnenblume',
    'FA-0037': 'Gartenzwerg-Sammlung',
    'FA-0038': 'Imker',
    'FA-0039': 'Silo',
    'FA-0040': 'Blumenwiese',
    'FA-0041': 'Liebevoller Bauer',
    'FA-0042': 'Saat sammeln',
    'FA-0043': 'Käfer finden',
    'FA-0044': 'Saatkolonie',
    'FA-0045': 'Riesenwurzel',
    'FA-0046': 'Schwarze Rosen',
    'FA-0047': 'Mähroboter',
    'FA-0048': 'Glitzerkorn',
    'FA-0049': 'Kraftbeere',

    'GA-0001': 'Marienkäfer',
    'GA-0002': 'Farbenfrohe Federn',
    'GA-0003': 'Limonade herstellen',
    'GA-0004': 'Algen',
    'GA-0005': 'Kunstmuseum',
    'GA-0006': 'Bleistiftzeichnung',
    'GA-0007': 'Stiftesammlung',
    'GA-0008': 'Sprühgemälde',
    'GA-0009': 'Farbpalette',
    'GA-0010': 'Wandgemälde',
    'GA-0011': 'Unterschrift des Künstlers',
    'GA-0012': 'Farben mischen',
    'GA-0013': 'Moderne Kunstauktion',
    'GA-0014': 'Portrait',
    'GA-0015': 'Abfalleimer',
    'GA-0016': 'Pizzalieferung',
    'GA-0017': 'Paketelieferung',
    'GA-0018': 'Schulbus',
    'GA-0019': 'Farbtrommelfabrik',
    'GA-0020': 'Frachtschiff',
    'GA-0021': 'Umzugsunternehmen',
    'GA-0022': 'Drohnenlieferung',
    'GA-0023': 'Abschleppwagen',
    'GA-0024': 'Auto',
    'GA-0025': 'Gesicht',
    'GA-0026': 'Wasser',
    'GA-0027': 'Blume',
    'GA-0028': 'Haus',
    'GA-0029': 'Feuerpfeil',
    'GA-0030': 'Goldenes Schwert',
    'GA-0031': 'Fotograf',
    'GA-0032': 'Inspirierendes Banner',
    'GA-0033': 'Schiff in einer Flasche',
    'GA-0034': 'Gestrickter Pullover',
    'GA-0035': 'Möbel herstellen',
    'GA-0036': 'Holzschnitzen',
    'GA-0037': 'Bonsaibaum',
    'GA-0038': 'Figuren bemalen',
    'GA-0039': 'Verwirrung',
    'GA-0040': 'Rostige Farbtrommel',

    'GE-0001': 'Rubinbahn',
    'GE-0002': 'Smaragdmine',
    'GE-0003': 'Gesunkener Schatz',
    'GE-0004': 'Luxusuhr',
    'GE-0005': 'Gefährliche Dreiecke',
    'GE-0006': 'Diamantwerkzeuge',
    'GE-0007': 'Sicherheitsmaßnahmen',

    'EV-0001': 'Jahrmarkt',
    'EV-0002': 'Bauwettbewerb',
    'EV-0003': 'Grill',
    'EV-0004': 'Geburtstagsparty',
    'EV-0005': 'Gartenverkauf',
    'EV-0006': 'Tankstelle',
    'EV-0007': 'Händler vor Ort',
    'EV-0008': 'Bingo im Fernsehen',
    'EV-0009': 'Casino',
    'EV-0010': '???',
    'EV-0011': 'Banktresor',
    'EV-0012': 'Profit!',
    'EV-0013': 'Kreditkarte',
    'EV-0014': 'Wüste',
    'EV-0015': 'Paragliding',
    'EV-0016': 'Dschungelrätsel',
    'EV-0017': 'Gestrandete Schildkröte',
    'EV-0018': 'Blumenzucht',
    'EV-0019': 'Pflanzenprobe',
    'EV-0020': 'Speerfischen',
    'EV-0021': 'Schneckenrennen',
    'EV-0022': 'Einsame Insel',
    'EV-0023': 'Sommerlied',
    'EV-0024': 'Gemütliche Couch',
    'EV-0025': 'Ungemütlicher Berg',
    'EV-0026': 'Stadt bei Nacht',
    'EV-0027': 'Heißer Apfelsaft',
    'EV-0028': 'Mysteriöse Suppe',
    'EV-0029': 'Geheime Quelle',
    'EV-0030': 'Schneemann bauen',
    'EV-0031': 'Wintersport',
    'EV-0032': 'Burgbeleuchtung',
    'EV-0033': 'Glühbirnen-Geschäft',

    'XD-1337': 'Testkarte'
  },
  collection: {
    minersAndEquipment: 'Bergleute und Ausrüstung',
    scrapLogistics: 'Schrottlogistik',
    caveLocations: 'Höhlenorte',
    dangersInTheDark: 'Gefahren im Dunkeln',
    versatile: 'Vielseitig',
    neighborhood: 'Nachbarschaft',
    plantsInTheCity: 'Grün in der Stadt',
    industrialRevolution: 'Industrielle Revolution',
    maintainingSafety: 'Sicherheit bewahren',
    localBusiness: 'Örtliche Geschäfte',
    dangerousWeapons: 'Gefährliche Waffen',
    supplyAndSupport: 'Helfen und Versorgen',
    againstTheCorruption: 'Gegen die Korruption',
    artOfWar: 'Kriegskunst',
    skillfulCombat: 'Geschickter Kampf',
    feedingTheWorld: 'Die Welt ernähren',
    organicDyes: 'Organische Farbe',
    countryLife: 'Dorfleben',
    forgottenPlants: 'Vergessene Pflanzen',
    artDisplay: 'Kunstausstellung',
    deliveryService: 'Lieferdienst',
    abstractShapes: 'Abstrakte Formen',
    handmade: 'Handgemacht',
    preciousJewelry: 'Wertvolle Juwelen',
    weekendTrip: 'Wochenendausflug',
    tropicalParadise: 'Tropisches Paradies',
    coldTimes: 'Kalte Zeiten',
    specialGadgets: 'Spezialwerkzeug',
  },
  pack: {
    intoDarkness: 'In die Dunkelheit',
    drillsAndDepths: 'Bohrer und Tiefen',
    hotStuff: 'Heißes Zeug',
    dangerZone: 'Gefahrenzone',
    cloudsAndSmoke: 'Wolken und Rauch',
    deepHole: 'Tiefes Loch',
    blackDust: 'Schwarzer Staub',
    meetingNewPeople: 'Neue Leute treffen',
    darkCult: 'Dunkler Kult',
    technologicalAdvancement: 'Technologischer Fortschritt',
    wasteDisposal: 'Müllentsorgung',
    settingUpShop: 'Ladeneröffnung',
    merchantUnion: 'Händlergewerkschaft',
    rookieOnTheBattlefield: 'Neuling auf dem Schlachtfeld',
    spiritualSuccess: 'Spiritueller Erfolg',
    oldMemories: 'Alte Erinnerungen',
    taintedWorld: 'Verdorbene Welt',
    towerOfPower: 'Kraftturm',
    learnToFight: 'Lerne zu kämpfen',
    combatExpert: 'Kampfexperte',
    bountifulHarvest: 'Ertragreiche Ernte',
    juicyYields: 'Saftiger Ertrag',
    insectWorld: 'Insektenwelt',
    beesAndFlowers: 'Bienen und Blümchen',
    strongPlants: 'Starke Pflanzen',
    seedVariety: 'Saatvielfalt',
    newArtist: 'Neuer Künstler',
    inspiringCreations: 'Inspirierende Werke',
    differentColors: 'Unterschiedliche Farben',
    bigCanvas: 'Große Leinwand',
    famousPainter: 'Berühmter Maler',
    goodDeal: 'Guter Tausch',
    connectedLine: 'Verbundene Linie',
    feelingLucky: 'Glücksgefühl',
    investorsDream: 'Investorentraum',
    greenThumb: 'Grüner Daumen',
    fishingForFun: 'Angeln aus Spaß',
    charmingShip: 'Bezauberndes Schiff',
    midnightAnomaly: 'Mitternachtsanomalie',
    icyWonderland: 'Eisiges Wunderland',
    sparksOfJoy: 'Funken der Freude',
  }
};
